var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
import ServiceOfferingDomainService from "../Domain/ServiceOffering/ServiceOffering.service";
const BASE_REQUEST = "/aviso/serviceOffering";
export default class ServiceOfferingService {
    static searchActive(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/serviceOfferings/search/searchActive", {
                params: { search },
            });
            return response.data._embedded.serviceOfferings;
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/serviceOfferings/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.serviceOfferings;
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const ret = yield FetchService.getPagedResponse(BASE_REQUEST + "/search", {
                query: search.query,
                serviceOfferingIdsInclude: search.serviceOfferingIdsInclude,
                active: search.active,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
            return Object.assign(Object.assign({}, ret), { data: ret.data.map(ServiceOfferingDomainService.fromJSON) });
        });
    }
    static save(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_REQUEST + "/save", request).then(ServiceOfferingDomainService.fromJSON);
        });
    }
    static get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_REQUEST + "/get", {
                id,
            }).then(ServiceOfferingDomainService.fromJSON);
        });
    }
    static bulkToggleActivation(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_REQUEST + "/bulkToggleActivation", {
                request,
            });
        });
    }
}
